/* Urun galerisini SECILEN yon ve cerceve rengine gore filtreler.
 *
 * Kullanici (12 Eylul 2026): "beyaz cerceveye sectigimde beyaza donusmuyor".
 * Olculdu: kapak donuyordu; galeride duran oda fotografi siyah cerceveli
 * kaliyordu ve uc yonun (dikey/yatay/kare) yardimci gorselleri de ayni anda
 * duruyordu. Temanin `hide_variants` ayari yalniz VARYANTA BAGLI medyayi
 * (kapaklar) teke dusuruyor; lifestyle / yakin cekim / boyut semasi varyanta
 * bagli olmadigi icin hepsi gorunuyor.
 *
 * Neden JS: bu uc gorseli varyanta baglamak cozum DEGIL - `hide_variants`
 * varyanta bagli medyadan yalniz "secili varyantin kapagi"ni birakiyor,
 * digerlerini komple gizliyor. Yani baglarsak oda fotografi hic gorunmez.
 *
 * ESLESME DOSYA ADINDAN: gorseller `<slug>-<yon>[-beyaz]-<tur>.png`
 * kalibinda uretiliyor (poster_gorselleri.py / cerceve_secenegi.py).
 *   - yon eki yoksa gorsel her yonde gosterilir (eski tek yonlu urunler)
 *   - renk yalnizca "lifestyle" icin anlamli; closeup ve boyut semasinda
 *     cerceve CIZILMIYOR, onlar renkten bagimsiz
 */
(function () {
  var YONLER = ['dikey', 'yatay', 'kare'];

  // Gizleme kurali tek yerde; ayri bir CSS dosyasi yuklemeye gerek yok.
  if (!document.getElementById('cp-galeri-filtre-stil')) {
    var stil = document.createElement('style');
    stil.id = 'cp-galeri-filtre-stil';
    stil.textContent =
      '[data-cp-gizli]{display:none !important}' +
      /* ACILIS PARLAMASI (21 Eylul 2026, kullanici bildirdi: "ilk 2 saniye
         tum fotolar gorunuyor, sonra kendine geliyor"). JS calisana kadar
         tarayici TUM slaytlari cizmis oluyor. Ilk slayt (kapak) zaten dogru
         secim; kalanlar filtre ilk kez calisana kadar gizli tutuluyor.
         Guvenlik: 2,5 sn sonra kosulsuz aciliyor, JS bir sekilde
         calismazsa galeri gizli kalmasin. */
      'body:not(.cp-filtre-hazir) ul.media-gallery__grid > li.product-media-container:not(:first-child),' +
      'body:not(.cp-filtre-hazir) slideshow-slide:not(:first-of-type){visibility:hidden}' +
      '.cp-paspartu{display:flex;gap:.6rem;align-items:flex-start;' +
      'margin:.9rem 0;padding:.75rem .9rem;border:1px solid rgba(0,0,0,.14);' +
      'border-radius:.6rem;cursor:pointer;line-height:1.35}' +
      '.cp-paspartu input{margin-top:.15rem;width:1.05rem;height:1.05rem;flex:0 0 auto;cursor:pointer}' +
      '.cp-paspartu__metin{display:flex;flex-direction:column;gap:.15rem}' +
      '.cp-paspartu__ad{font-weight:600}' +
      '.cp-paspartu__not{font-size:.85em;opacity:.7}' +
      /* Cerceve rengi (19 Eylul 2026, renk_secici.py) */
      '.cp-renk{margin:.9rem 0}' +
      '.cp-renk__baslik{display:block;font-weight:600;margin-bottom:.45rem}' +
      '.cp-renk__secenek{display:inline-flex;align-items:center;gap:.35rem;'+
      'margin:0 .5rem .4rem 0;padding:.3rem .55rem;border:1px solid rgba(0,0,0,.16);'+
      'border-radius:2rem;cursor:pointer;line-height:1.2}' +
      '.cp-renk__secenek input{position:absolute;opacity:0;pointer-events:none}' +
      '.cp-renk__secenek:has(input:checked){border-color:rgba(0,0,0,.75);'+
      'box-shadow:0 0 0 1px rgba(0,0,0,.55) inset}' +
      '.cp-renk__nokta{width:1.05rem;height:1.05rem;border-radius:50%;'+
      'border:1px solid rgba(0,0,0,.25);flex:0 0 auto}' +
      '.cp-renk__ad{font-size:.9em}';
    document.head.appendChild(stil);
  }

  function secili() {
    var sonuc = { yon: null, cerceve: null, model: null, paspartu: false };
    // Paspartu artik varyant DEGIL, satir ozelligi - durumu onay kutusundan
    // okunuyor (bkz. paspartu_kutucuk.py). Yapistirma cubugundaki kopya da
    // ayni adi tasiyabilir; herhangi biri isaretliyse paspartulu sayiyoruz.
    var kutular = document.querySelectorAll('[data-cp-paspartu]');
    for (var k = 0; k < kutular.length; k++) {
      if (kutular[k].checked) sonuc.paspartu = true;
    }
    var girdiler = document.querySelectorAll(
      'input[type="radio"]:checked, select option:checked');
    for (var i = 0; i < girdiler.length; i++) {
      var d = (girdiler[i].value || '').trim();
      // Degisken adi `k` DEGIL: yukaridaki dongu de `k` kullaniyor ve `var`
      // fonksiyon kapsamli - ayni adi tekrar kullanmak ileride tuzak olur.
      var kucuk = d.toLocaleLowerCase('tr');
      if (YONLER.indexOf(kucuk) !== -1) sonuc.yon = kucuk;
      // "Siyah", "Beyaz", "Siyah + paspartu", "Beyaz + paspartu"
      if (d.indexOf('Beyaz') === 0) sonuc.cerceve = 'beyaz';
      else if (d.indexOf('Siyah') === 0) sonuc.cerceve = 'siyah';
      // MODEL (15 Eylul 2026): "Siyah Derin" / "Beyaz Derin" -> derin;
      // yalin "Siyah" / "Beyaz" -> basic. Deger RENKLE basladigi icin
      // yukaridaki renk kurali degismeden calisiyor.
      if (d.indexOf('Siyah') === 0 || d.indexOf('Beyaz') === 0) {
        sonuc.model = / Derin$/.test(d) ? 'derin' : (/ Galeri$/.test(d) ? 'galeri' : 'basic');
      }
    }
    /* RENK DUGMESI varyanttan SONRA okunuyor ve onu EZIYOR: gecis
       doneminde urunun varyantinda hala "Siyah"/"Beyaz" olabilir, ama
       musterinin gordugu secim renk dugmesidir. */
    /* Ek renkler varyant DEGIL, properties[Renk] (bkz. cerceve-model-secici.js).
       Gizli alan oldugu icin ":checked" ARANMAZ - degeri okunur. Varyanttan
       gelen renkten SONRA bakiliyor ve onu eziyor: ek renk secildiginde
       varyant "Siyah" kalir ama musterinin gordugu renk budur. */
    var rd = document.querySelector('[data-cp-renk-secim]');
    var ozDeger = (window.__cpRenk || (rd && rd.value) || '').trim();
    if (ozDeger) {
      var anahtar = RENK_ANAHTAR[ozDeger];
      if (anahtar) sonuc.cerceve = anahtar;
    }
    return sonuc;
  }

  function dosyaAdi(slayt) {
    var im = slayt.querySelector('img');
    if (!im || !im.src) return null;
    return im.src.split('/').pop().split('?')[0].toLowerCase();
  }

  /* KAPAK MI? Iki adlandirma kusagi var (12 Eylul 2026'da yakalandi):
       yeni  -> "<slug>-<yon>-kapak.png", "<slug>-<yon>-beyaz-kapak.png"
       eski  -> "<slug>-poster.png"        (tek yonlu eski katalog)
     Ilk surum yalniz "kapak" ariyordu; eski kapak bu yuzden hicbir kurala
     takilmiyordu ve Beyaz secilince bile galeride ILK SIRADA duruyordu.
     "poster" kelimesi slug'larin ICINDE de gectigi icin (ornegin
     "akdeniz-...-poster-baskisi") gevsek arama yapilamaz - SONEK aranir. */
  function kapakMi(ad) {
    return ad.indexOf('kapak') !== -1 || /-poster(_[0-9a-f-]+)?\.png$/.test(ad);
  }

  /* BEYAZ MI? Slug'a takilmamali: "minimalist-beyaz-cicekler-poster.png"
     SIYAH kapak ama adinda "-beyaz-" geciyor (katalogda slug'inda "beyaz"
     gecen 3 aktif urun var). Yalniz BIZIM urettigimiz sonekler aranir. */
  function beyazMi(ad) {
    return /-beyaz-(derin-|galeri-)?(kapak|paspartulu|lifestyle)/.test(ad);
  }

  /* RENK (19 Eylul 2026): renk artik varyant DEGIL, properties[Renk].
     Siyah dosya adinda EKSIZ, digerleri "-<renk>-" tasiyor. Anahtarlar
     ACIK YAZILDI: "Kırmızı".toLowerCase() Turkce'de "kırmızı" veriyor ve
     dosya adindaki "kirmizi" ile TUTMUYOR (ayni tuzak koleksiyon
     handle'larinda yasandi). */
  var RENK_ANAHTAR = {
    'Siyah': 'siyah', 'Beyaz': 'beyaz', 'Ceviz': 'ceviz',
    'Kırmızı': 'kirmizi', 'Pembe': 'pembe', 'Sarı': 'sari', 'Mavi': 'mavi'
  };
  var EKLI_RENKLER = ['beyaz', 'ceviz', 'kirmizi', 'pembe', 'sari', 'mavi'];

  function dosyaRengi(ad) {
    for (var i = 0; i < EKLI_RENKLER.length; i++) {
      var r = EKLI_RENKLER[i];
      if (new RegExp('-' + r + '-(derin-|galeri-)?(kapak|paspartulu|lifestyle)').test(ad)) {
        return r;
      }
    }
    return 'siyah';
  }

  /* DERIN MI? derin_cerceve.py adlandirmasi: "-derin-kapak", "-beyaz-derin-kapak",
     "-derin-paspartulu", "-beyaz-derin-paspartulu". Lifestyle modelden bagimsiz. */
  /* Galeri (16 Eylul 2026): "-galeri-kapak", "-galeri-paspartulu" (yalniz siyah). */
  function dosyaModeli(ad) {
    // LIFESTYLE DE MODEL TASIYOR (20 Eylul 2026'da kullanici gordu: "basic
    // secili olmasina ragmen galeri ve derin gorseller de geldi"). Eskiden
    // oda fotografi TEK cesitti ve modelden bagimsizdi; artik her model ve
    // renk icin ayri oda fotografi var, o yuzden filtreye dahil.
    if (/-galeri-(kapak|paspartulu|lifestyle)/.test(ad)) return 'galeri';
    if (/-derin-(kapak|paspartulu|lifestyle)/.test(ad)) return 'derin';
    return 'basic';
  }

  function gosterilsinMi(ad, s) {
    if (!ad) return true;                       // gorsel olmayan slayt (video vb.)

    // --- yon
    // ODA FOTOGRAFI YONDEN BAGIMSIZ (20 Eylul 2026, kullanici karari):
    // oda sablonu yalniz DIKEY uretiliyor ve amaci cerceve stilini
    // gostermek. Yon filtresine girseydi musteri Yatay/Kare secince
    // galeride hic oda fotografi kalmazdi.
    if (s.yon && ad.indexOf('lifestyle') === -1) {
      var gorselYonu = null;
      for (var i = 0; i < YONLER.length; i++) {
        if (ad.indexOf('-' + YONLER[i] + '-') !== -1) gorselYonu = YONLER[i];
      }
      if (gorselYonu && gorselYonu !== s.yon) return false;
    }

    // --- renk (kapak ve lifestyle renk tasiyor; closeup ve boyut semasinda
    //     cerceve CIZILMIYOR, onlar renkten bagimsiz)
    var renkli = ad.indexOf('lifestyle') !== -1 || kapakMi(ad) ||
                 ad.indexOf('paspartulu') !== -1;
    if (s.cerceve && renkli) {
      if (s.cerceve !== dosyaRengi(ad)) return false;
    }

    // --- model: kapak ve paspartulu gorsellerin Basic ve Derin surumu var;
    //     secilmeyen modelinki gizlenir. Urunde derin gorsel yoksa (henuz
    //     eklenmemis urun) s.model 'basic' kalir ve hicbir sey degismez.
    var modelli = kapakMi(ad) || ad.indexOf('paspartulu') !== -1 ||
                  ad.indexOf('lifestyle') !== -1;
    if (s.model && modelli) {
      if (s.model !== dosyaModeli(ad)) return false;
    }

    // --- paspartu: kapak ve paspartulu ayni seyin iki hali, biri gosterilir
    if (ad.indexOf('paspartulu') !== -1) return s.paspartu;
    if (kapakMi(ad)) return !s.paspartu;
    return true;
  }

  /* SAYFA KORUMASI (12 Eylul 2026'da yakalandi - GERCEK YAN HASAR).
     Bu dosya theme.liquid'den YUKLENIYOR, yani HER sayfada calisiyor.
     Koleksiyon sayfasindaki urun kartlari da <slideshow-slide> kullaniyor:
     /collections/hayvanlar sayfasinda 198 kapsayici var ve paspartu kurali
     kosulsuz oldugu icin 24 gorsel GIZLENIYORDU - kartlarin uzerine gelince
     cikan ikinci fotograf. Filtrenin isi yalniz cerceve/paspartu secimi olan
     URUN sayfasi; baska yerde hicbir sey yapmamali. */
  function aktifMi() {
    return !!document.querySelector(
      'input[type="radio"][value="Siyah"], input[type="radio"][value="Beyaz"],' +
      ' input[type="radio"][value="Siyah Derin"], input[type="radio"][value="Beyaz Derin"],' +
      ' input[type="radio"][value="Siyah Galeri"],' +
      ' [data-cp-paspartu]');
  }

  /* Ikinci katman: urun sayfasinda bile yalniz GALERI bolumu taraniyor.
     Ayni sayfadaki "benzer urunler" kartlari da slideshow-slide tasiyabilir. */
  function galeriKoku() {
    var izgara = document.querySelector('ul.media-gallery__grid');
    if (izgara) {
      var bolum = izgara.closest('[id^="shopify-section"]');
      if (bolum) return bolum;
    }
    return document;
  }

  function uygula() {
    if (!aktifMi()) return;
    var s = secili();
    /* FORM HENUZ HAZIR DEGILSE DOKUNMA (19 Eylul 2026'da tarayicida
       yakalandi). Tema varyant degisince urun formunu yeniden ciziyor; o
       anda hicbir radyo "checked" olmuyor ve secili() bos donuyordu. Bos
       secimle filtre "hepsi gorunsun" diyip gizlemeleri KALDIRIYOR, sonra
       yeni olay gelmedigi icin galeri filtresiz kaliyordu - kullanici
       "renk secince gorsellerin yeri degisiyor" derken bunu goruyordu. */
    if (!s.yon && !s.cerceve && !s.model) return;
    // Slaytlar HER SEFERINDE bastan sorgulaniyor. Kok dugumu bir kez tutup
    // saklamak calismiyordu: tema varyant degisince bolumu yeniden ciziyor ve
    // slideshow-component dugumunun KENDISI degisiyor; saklanan referans
    // kopuk kaliyor, filtre bir daha hic uygulanmiyordu (12 Eylul 2026'da
    // tarayicida olculdu - Siyah'a donunce 15 slaytin 15'i gorunuyordu).
    // UC AYRI KAP var ve ucu de filtrelenmeli (12 Eylul 2026'da olculdu):
    //   li.product-media-container  -> masaustu IZGARA (ul.media-gallery__grid)
    //   slideshow-slide             -> mobil karusel VE buyutme penceresi
    // Once yalniz slideshow-slide filtrelenmisti; ekranda hicbir sey degismedi
    // cunku masaustunde gorunen izgaraydi, slaytlarin genisligi 0'di.
    var slaytlar = galeriKoku().querySelectorAll(
      'li.product-media-container, slideshow-slide');
    /* O RENGIN GORSELI YOKSA SIYAHA DON (19 Eylul 2026). Renk dugmeleri
       katalogun tamamina ayni anda giriyor ama renk gorselleri urun urun
       uretiliyor; henuz kirmizisi olmayan bir urunde Kirmizi secilince
       filtre TUM kapaklari eler ve galeri bos kalirdi. */
    if (s.cerceve && s.cerceve !== 'siyah') {
      var varMi = false;
      for (var v = 0; v < slaytlar.length; v++) {
        var va = dosyaAdi(slaytlar[v]);
        if (va && dosyaRengi(va) === s.cerceve) { varMi = true; break; }
      }
      if (!varMi) s.cerceve = 'siyah';
    }
    for (var i = 0; i < slaytlar.length; i++) {
      var ad = dosyaAdi(slaytlar[i]);
      var goster = gosterilsinMi(ad, s);
      // `hidden` yerine data + CSS: slideshow bileseni kendi aria-hidden'ini
      // yonetiyor, onun ozniteligini ezmek gezinmeyi bozuyordu.
      slaytlar[i].toggleAttribute('data-cp-gizli', !goster);
      if (slaytlar[i].tagName === 'SLIDESHOW-SLIDE') {
        // Horizon navigates its non-hidden slides; CSS alone leaves invisible
        // variants in the swipe/arrow sequence.
        slaytlar[i].toggleAttribute('hidden', !goster);
        if (!goster) slaytlar[i].removeAttribute('reveal');
      }
    }

    /* NOKTALAR DA GIZLENMELI (kullanici, 13 Eylul 2026: "asagida yuvarlaklar
       var, geciyor ama yuvarlaklar cok fazla, o kadar foto yok ki; sonuna
       gelince 4.-5.'de kaliyor, daha foto varmis da goremiyormusuz gibi").
       Slideshow noktalarini TUM slaytlar icin ciziyor; gizlediklerimizin
       noktasi duruyordu. Nokta ve slayt sirasi birebir ayni (olculdu: 8
       slayt / 8 nokta), indeksle eslestiriliyor. Sayilar tutmuyorsa
       DOKUNULMUYOR - yanlis noktayi gizlemektense hic gizlememek iyidir. */
    galeriKoku().querySelectorAll('slideshow-component').forEach(function (component) {
      var slides = component.querySelectorAll('slideshow-slide');
      var dots = component.querySelectorAll('[ref="dots[]"]');
      slides.forEach(function (slide) {
        var media = slide.querySelector('[data-media-id]');
        if (media && !slide.getAttribute('slide-id')) slide.setAttribute('slide-id', media.getAttribute('data-media-id'));
      });
      if (slides.length === dots.length) dots.forEach(function (dot, index) {
        if (!dot.dataset.cpSlideId || dot.dataset.cpSlideId === 'null') dot.dataset.cpSlideId = slides[index].getAttribute('slide-id');
      });
      if (component.__cpSelection !== JSON.stringify(s)) {
        component.__cpSelection = JSON.stringify(s);
        requestAnimationFrame(function () {
          var cover = Array.from(component.querySelectorAll('slideshow-slide:not([data-cp-gizli])')).find(function (slide) {
            var ad = dosyaAdi(slide) || '';
            return kapakMi(ad) || ad.indexOf('paspartulu') !== -1;
          });
          if (cover && component.isConnected && typeof component.select === 'function') {
            component.select({ id: cover.getAttribute('slide-id') }, undefined, { animate: false });
          }
        });
      }
    });
    // Keep the selected white-background cover ahead of the shared lifestyle.
    // A sideways/square cover used to follow the vertical lifestyle in DOM order.
    var ilkler = new Map();
    for (var c = 0; c < slaytlar.length; c++) {
      var node = slaytlar[c];
      var name = dosyaAdi(node) || '';
      if (!node.hasAttribute('data-cp-gizli') &&
          (kapakMi(name) || name.indexOf('paspartulu') !== -1) &&
          !ilkler.has(node.parentElement)) ilkler.set(node.parentElement, node);
    }
    ilkler.forEach(function (cover, parent) {
      if (parent.firstElementChild !== cover) parent.insertBefore(cover, parent.firstElementChild);
    });
    var kaplar = galeriKoku().querySelectorAll('slideshow-component');
    for (var k = 0; k < kaplar.length; k++) {
      var sl = kaplar[k].querySelectorAll('slideshow-slide');
      var nk = kaplar[k].querySelectorAll('[ref="dots[]"]');
      if (!nk.length || nk.length !== sl.length) continue;
      for (var j = 0; j < nk.length; j++) {
        var kutu = nk[j].closest('li') || nk[j];
        var target = Array.from(sl).find(function (item) { return item.getAttribute('slide-id') === nk[j].dataset.cpSlideId; });
        if (target) kutu.toggleAttribute('data-cp-gizli', target.hasAttribute('data-cp-gizli'));
      }
    }
  }

  var bekleyen = false;
  function planla() {
    if (bekleyen) return;
    bekleyen = true;
    queueMicrotask(function () { bekleyen = false; uygula(); });
  }
  uygula();
  document.body.classList.add('cp-filtre-hazir');
  document.addEventListener('change', planla, true);
  document.addEventListener('cp:selection-change', planla);
  document.addEventListener('click', function (event) {
    var dot = event.target.closest && event.target.closest('[data-cp-slide-id]');
    if (!dot) return;
    var component = dot.closest('slideshow-component');
    if (!component || typeof component.select !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    component.select({ id: dot.dataset.cpSlideId }, undefined, { animate: false });
  }, true);
  new MutationObserver(planla).observe(document.body, { childList: true, subtree: true });
})();
